import { useMemo } from 'react';

import type { DashboardAuthAdapter, DashboardAuthContextValue } from '@tide/dashboard-shell';

import useAuth from 'hooks/useAuth';

export const portalDashboardAuthAdapter: DashboardAuthAdapter = {
  useAuth: () => {
    const { isInitialized, isLoggedIn, user, logout } = useAuth();

    return useMemo<DashboardAuthContextValue>(
      () => ({
        status: !isInitialized ? 'loading' : isLoggedIn ? 'authenticated' : 'unauthenticated',
        statusLabel: !isInitialized ? 'Loading auth' : isLoggedIn ? 'Signed in' : 'Signed out',
        user: user
          ? {
              email: user.email,
              name: user.name,
              permissions: [],
              roles: []
            }
          : undefined,
        signOut: logout
      }),
      [isInitialized, isLoggedIn, logout, user]
    );
  }
};
